module.exports = __webpack_public_path__ + "static/media/cuttingRoom.b3935d3d.png";